import React from 'react'
import { Container, Typography } from '@mui/material'
import { ResponsivePie } from '@nivo/pie'
import { getChartData } from '../services/getChartData'
import { useState, useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { CircularProgress } from '@mui/material'

const GraficoPie2 = props => {
  const [chartData, setChartData] = useState([])
  const { data, isFetching, isError, refetch } = useQuery(
    ['grafico-tipo-inserimento', props.searchPraticheChiuse],
    () => getChartData('tipoinserimento', props.searchPraticheChiuse),
  )

  useEffect(() => {
    refetch()
  }, [props.searchPraticheChiuse, refetch])
  useEffect(() => {
    try {
      if (data !== undefined) {
        setChartData(
          data?.map(val => {
            return { id: val.label, value: val.count, label: val.label }
          }),
        )
      }
    } catch (error) {

    }
  }, [data])

  return (
    <Container
      sx={{
        height: { xs: '20rem', xl: '25rem' },
        width: { xs: '100%', xl: '80%' },
      }}
    >
      {isError && <Typography>{'Errore nella ricezione dei dati'}</Typography>}
      {isFetching ? (
        <CircularProgress />
      ) : (
        <ResponsivePie
          data={
            chartData.length > 0 ? chartData : [{ id: '', value: 0, label: '' }]
          }
          margin={{ top: 20, right: 90, bottom: 90, left: 90 }}
          
          innerRadius={0.5}
          padAngle={0.7}
          cornerRadius={3}
          activeOuterRadiusOffset={8}
          colors={props.colors}
          borderWidth={1}
          borderColor={{
            from: 'color',
            modifiers: [['darker', 0.2]],
          }}
          arcLinkLabelsStraightLength={6}
          arcLinkLabelsTextOffset={2}
          arcLinkLabelsDiagonalLength={4}
          arcLinkLabelsSkipAngle={1}
          arcLinkLabelsTextColor="#333333"
          arcLinkLabelsThickness={2}
          arcLinkLabelsColor={{ from: 'color' }}
          arcLabelsSkipAngle={10}
          arcLabelsTextColor={{
            from: 'color',
            modifiers: [['darker', 2]],
          }}
          defs={[
            {
              id: 'dots',
              type: 'patternDots',
              background: 'inherit',
              color: 'rgba(255, 255, 255, 0.3)',
              size: 4,
              padding: 1,
              stagger: true,
            },
            {
              id: 'lines',
              type: 'patternLines',
              background: 'inherit',
              color: 'rgba(255, 255, 255, 0.3)',
              rotation: -45,
              lineWidth: 6,
              spacing: 10,
            },
          ]}
          legends={[
            {
              anchor: 'bottom-left',
              direction: 'column',
              justify: false,
              translateX: -80,
              translateY: 80,
              itemWidth: 100,
              itemHeight: 20,
              itemsSpacing: 0,
              symbolSize: 10,
              itemDirection: 'left-to-right',
            },
          ]}
        />
      )}
    </Container>
  )
}

export default GraficoPie2

